import React from 'react'
import Checkbox from '../Fields/Checkbox'
import SingleInput from '../Fields/SingleInput'

import classes from './layout.css'

const ModuleTwelve = (props) => {
	return (
		<ol>
			<div className={classes.Section}>
				<h3>GENERAL RISKS</h3>
				<li id="1">
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox1"}
						value={props.consentForm.cBox1}
					/>
					Bleeding, swelling, infection, scarring, pain, numbness or altered sensation (possibly permanent) at the donor site which may require further treatment.
				</li>
				<li id="2">
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox2"}
						value={props.consentForm.cBox2}
					/>
					Allergic or other adverse reaction to the drugs used during or after the procedure.
				</li>
				<li id="3">
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox3"}
						value={props.consentForm.cBox3}
					/>
					The need for additional or more extensive procedures in order to obtain sufficient bone.
				</li>
				<li id="4">
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox4"}
						value={props.consentForm.cBox4}
					/>
					Rejection of bone particles from donor or recipient sites for some time after surgery.
				</li>
				<li id="5">
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox5"}
						value={props.consentForm.cBox5}
					/>
					Rejection of the bone graft.
				</li>
			</div>
			<div className={classes.Section}>
				<h3>RISKS AND COMPLICATIONS OF GRAFTING FROM WITHIN THE MOUTH AREA</h3>

				<li id="6">
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox6"}
						value={props.consentForm.cBox6}
					/>
					Damage to adjacent teeth which may require future root canal procedures, or may cause loss of those teeth.
				</li>
				<li id="7">
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox7"}
						value={props.consentForm.cBox7}
					/>
					Removal of adult teeth in order to obtain sufficient bone material.
				</li>
				<li id="8">
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox8"}
						value={props.consentForm.cBox8}
					/>
					Numbness or pain in the area of the donor or recipient site, or more extensive area, which may be temporary or permanent.
				</li>
				<li id="9">
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox9"}
						value={props.consentForm.cBox9}
					/>
					Penetration of the sinus or nasal cavity in the upper jaw, which could result in infection or other complication requiring additional drug or surgical treatment.
				</li>
			</div>
			<div className={classes.Section}>
				<h3>BANKED BONE OR BONE SUBSTITUTES</h3>
				<p>On occasion, additional donated, processed, or artificial bone substitutes are used to supplement the patient’s bone, or to spare an extensive graft harvesting procedure. If used, such materials may have separate risks including, but not limited to:</p>

				<li id="10">
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox10"}
						value={props.consentForm.cBox10}
					/>
					Rejection of the donated or artificial graft material.
				</li>
				<li id="11">
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox11"}
						value={props.consentForm.cBox11}
					/>
					The remote chance of viral or bacterial disease transmission from processed bone.
					I understand that in my grafting procedure, the use of autogenous bone taken from my ramus (lower jaw), and/or tuberosity (upper jaw) area plus
					<SingleInput
						name={"sentence"}
						controlFunc={props.addToForm}
						inputType={"text"}
						value={props.consentForm.sentence}
					/>.
				</li>
				<li id="12">
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox12"}
						value={props.consentForm.cBox12}
					/>
					The anesthetic I have chosen for my surgery is:<br />
					<div className={classes.Anesthesia}>
						<Checkbox
							name={"cBox12AnesthesiaOptions"}
							id={"1"}
							controlFunc={props.addToForm}
							value={props.consentForm.cBox12AnesthesiaOptions[1]}
						/>Local Anesthesia<br />

						<Checkbox
							name={"cBox12AnesthesiaOptions"}
							id={"2"}
							controlFunc={props.addToForm}
							value={props.consentForm.cBox12AnesthesiaOptions[2]}
						/>Nitrous Oxide/Oxygen Analgesia with Local Anesthesia	<br />

						<Checkbox
							name={"cBox12AnesthesiaOptions"}
							id={"3"}
							controlFunc={props.addToForm}
							value={props.consentForm.cBox12AnesthesiaOptions[3]}
						/>Oral Premedication with Local Anesthesia<br />

						<Checkbox
							name={"cBox12AnesthesiaOptions"}
							id={"4"}
							controlFunc={props.addToForm}
							value={props.consentForm.cBox12AnesthesiaOptions[4]}
						/>Intravenous Sedation with Local Anesthesia<br />

						<Checkbox
							name={"cBox12AnesthesiaOptions"}
							id={"5"}
							controlFunc={props.addToForm}
							value={props.consentForm.cBox12AnesthesiaOptions[5]}
						/>Deep Sedation with Local Anesthesia
					</div>
				</li>
				<li id="13">
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox13"}
						value={props.consentForm.cBox13}
					/>
					<strong><u>ANESTHETIC RISKS</u></strong> include: pain, swelling, bruising, swelling or infection of the vein area where the anesthesia or sedation was given. This could last a long time or make it hard for you to use your arm. This might need special care. There might be numbness that lasts a long time and allergic reactions. You might have nausea and vomiting from the IV Sedation or General Anesthesia, but this doesn’t happen often. IV Sedation and General Anesthesia are serious medical procedures. They are safe, but the rare risks of heart irregularities, heart attack, stroke, brain damage or death are present.
				</li>
				<li id="14">
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox14"}
						value={props.consentForm.cBox14}
					/>
					<strong><u>YOUR OBLIGATIONS FOR IV SEDATION OR DEEP SEDATION IS:</u></strong>
					<ol type="A">
						<li>Because anesthetic medications cause prolonged drowsiness, you MUST be accompanied by a responsible adult to drive you home and stay with you until you are sufficiently recovered to care for yourself. This may be up to 24 hours.</li>
						<li>During recovery time you should not drive, operate complicated machinery or devices, or make important decisions.</li>
						<li>You must have a completely empty stomach. <u>IT IS VITAL THAT YOU HAVE <strong>NOTHING</strong> TO EAT OR DRINK FOR <strong>EIGHT</strong> (8) HOURS PRIOR TO YOUR ANESTHETIC. <strong>TO DO OTHERWISE MAY BE LIFE-THREATENING!</strong></u></li>
						<li><strong>However</strong>, it is important to take any regular medications (high blood pressure, antibiotics, etc.) or any medications directed by us, <strong><u>with only a small sip of water.</u></strong></li>
					</ol>
				</li>
				<li id="15">
					<Checkbox
						controlFunc={props.addToForm}
						name={"cBox15"}
						value={props.consentForm.cBox15}
					/>
					<strong>TOBACCO USE:</strong> I understand that tobacco use is extremely detrimental to the success of bone grafting procedure. I agree to cease all use of tobacco use for 2-3 weeks prior to and after surgery, including the later uncovering procedure. I also agree to make a strong effort to give up tobacco use entirely. I understand that failure to comply with the above recommendations dramatically increases my risk of failing bone graft.
				</li>
			</div>
		</ol>
	)
}

export default ModuleTwelve


// WEBPACK FOOTER //
// ./src/components/Modules/13.js